import type { ReactNode } from "react";
import Breadcrumb, { type Crumb } from "@/components/feature/Breadcrumb";

interface PageHeaderProps {
  eyebrow?: string;
  title: string;
  description?: string;
  crumbs: Crumb[];
  children?: ReactNode;
}

export default function PageHeader({ eyebrow, title, description, crumbs, children }: PageHeaderProps) {
  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1200px] px-4 py-8 md:px-6 md:py-12">
        <Breadcrumb items={crumbs} />
        <div className="mt-5 md:mt-6">
          {eyebrow && (
            <span className="mb-2 inline-flex items-center gap-2 text-xs font-medium tracking-widest text-accent-600">
              <span className="h-1.5 w-1.5 rounded-full bg-accent-500"></span>
              {eyebrow}
            </span>
          )}
          <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">{title}</h1>
          {description && <p className="mt-3 max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base">{description}</p>}
        </div>
        {children && <div className="mt-6 md:mt-8">{children}</div>}
      </div>
    </section>
  );
}